import { Form, Spin, Typography } from "antd/es";
import { connect } from "react-redux";
import {
  HorizontalStack,
  Icon,
  KCol,
  KPanel,
  KRow,
  KTab,
  KTabItem,
  KTable,
  KTableColumn,
  KTableHeader,
  KTableRow,
  Label,
  VerticalStack,
} from "../../components/web-components";
import {
  hideImportMappedExcelModal,
  hideIyzicoDrawer,
  hidePhotoTake,
  hideStripeDrawer,
  showImportMappedExcelModal,
  showIyzicoDrawer,
  showPhotoTake,
  showStripeDrawer,
} from "../../redux/modals/actions";
import { AppState } from "../../redux/root-reducer";
import { withContext } from "../../shared/hoc/with-context";
import { withForm } from "../../shared/hoc/with-form";
import { withGoogleLogin } from "../../shared/hoc/with-google-login";
import { withHistory } from "../../shared/hoc/with-history";
import { withScreenInput } from "../../shared/hoc/with-screen-input";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";
import { BildirimListesi_ScreenBase } from "./bildirimlistesi-base";

declare let window: any;
const { Title, Paragraph, Text, Link } = Typography;
const menuMap = [];

class BildirimListesi_Screen extends BildirimListesi_ScreenBase {
  render() {
    if (this.state.isPageVisible === false) {
      return <></>;
    }
    return (
      <>
        <Spin spinning={this.state.spinnerCount > 0}>
          <Form
            form={this.props.form}
            name="basic"
            component={false}
            initialValues={{ bildirimlistesi_560805_value: undefined }}
            onValuesChange={(changedValues, allValues) => {
              this.clearFieldValidation(changedValues);
            }}
          >
            <>
              <div
                key="-1"
                id="bildirimlistesi_body"
                style={
                  {
                    borderStyle: "solid",
                    borderTopWidth: 0,
                    borderRightWidth: 0,
                    borderBottomWidth: 0,
                    borderLeftWidth: 0,
                    backgroundColor: "rgba(244, 244, 244, 1)",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "contain",
                    backgroundPosition: "left",
                    display: "block",
                    overflow: "auto",
                    minHeight:
                      "calc(100vh - 0px - 0px - 0px - 0px - 0px - 0px)",
                    maxHeight:
                      "calc(100vh - 0px - 0px - 0px - 0px - 0px - 0px)",
                    height: "calc(100vh - 0px - 0px - 0px - 0px - 0px - 0px)",
                  } as any
                }
              >
                <KRow
                  key="481985"
                  id="481985"
                  align="top"
                  justify="start"
                  horizontalGutter={0}
                  verticalGutter={0}
                  style={
                    {
                      borderStyle: "solid",
                      borderTopWidth: 0,
                      borderRightWidth: 0,
                      borderBottomWidth: 0,
                      borderLeftWidth: 0,
                      paddingTop: 8,
                      paddingRight: 8,
                      paddingBottom: 8,
                      paddingLeft: 8,
                      alignItems: "flex-start",
                      textAlign: "-webkit-left",
                    } as any
                  }
                >
                  <KCol
                    key="671715"
                    id="671715"
                    xs={24}
                    sm={24}
                    md={24}
                    lg={24}
                    xl={24}
                    xxl={24}
                    order={0}
                    pull={0}
                    push={0}
                    style={
                      {
                        borderStyle: "solid",
                        borderTopWidth: 0,
                        borderRightWidth: 0,
                        borderBottomWidth: 0,
                        borderLeftWidth: 0,
                        paddingTop: 8,
                        paddingRight: 8,
                        paddingBottom: 8,
                        paddingLeft: 8,
                        alignItems: "flex-start",
                        textAlign: "-webkit-left",
                      } as any
                    }
                  >
                    <KRow
                      key="334762"
                      id="334762"
                      align="top"
                      justify="start"
                      horizontalGutter={0}
                      verticalGutter={0}
                      style={
                        {
                          borderStyle: "solid",
                          borderTopWidth: 0,
                          borderRightWidth: 0,
                          borderBottomWidth: 0,
                          borderLeftWidth: 0,
                          paddingTop: 8,
                          paddingRight: 8,
                          paddingBottom: 8,
                          paddingLeft: 8,
                          alignItems: "flex-start",
                          textAlign: "-webkit-left",
                        } as any
                      }
                    >
                      <KCol
                        key="650435"
                        id="650435"
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <KRow
                          key="587963"
                          id="587963"
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 0,
                              paddingRight: 0,
                              paddingBottom: 0,
                              paddingLeft: 0,
                            } as any
                          }
                        >
                          <KCol
                            key="447430"
                            id="447430"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={6}
                            xxl={6}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <KPanel
                              key="842965"
                              id="842965"
                              scrolling="hidden"
                              scrollRadius={false}
                              style={
                                {
                                  borderTopLeftRadius: 18,
                                  borderTopRightRadius: 18,
                                  borderBottomRightRadius: 18,
                                  borderBottomLeftRadius: 18,
                                  boxShadow: "0px 6px 16px 0px #d7dee8",
                                  backgroundColor: "#ffffff",
                                  paddingTop: 28,
                                  paddingRight: 24,
                                  paddingBottom: 28,
                                  paddingLeft: 24,
                                } as any
                              }
                            >
                              <KRow
                                key="293780"
                                id="293780"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="479699"
                                  id="479699"
                                  xs={8}
                                  sm={8}
                                  md={8}
                                  lg={8}
                                  xl={8}
                                  xxl={8}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-center",
                                    } as any
                                  }
                                >
                                  <Icon
                                    key="150653"
                                    id="150653"
                                    iconName="notifications"
                                    style={
                                      {
                                        borderTopLeftRadius: 14,
                                        borderTopRightRadius: 14,
                                        borderBottomRightRadius: 14,
                                        borderBottomLeftRadius: 14,
                                        backgroundColor: "#e9f0fb",
                                        paddingTop: 10,
                                        paddingRight: 10,
                                        paddingBottom: 10,
                                        paddingLeft: 10,
                                        fontSize: "28px",
                                        color: "#f4b63c",
                                      } as any
                                    }
                                  ></Icon>
                                </KCol>
                                <KCol
                                  key="601955"
                                  id="601955"
                                  xs={16}
                                  sm={16}
                                  md={16}
                                  lg={16}
                                  xl={16}
                                  xxl={16}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      alignItems: "center",
                                    } as any
                                  }
                                >
                                  <VerticalStack
                                    key="679549"
                                    id="679549"
                                    direction="vertical"
                                    size={2}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <Label
                                      key="2934"
                                      id="2934"
                                      writingMode="horizontal"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Poppins",
                                          fontWeight: 700,
                                          fontSize: "18px",
                                          color: "#0f2340",
                                        } as any
                                      }
                                    ></Label>
                                    <Label
                                      key="258299"
                                      id="258299"
                                      value={ReactSystemFunctions.translate(
                                        this.ml,
                                        258299,
                                        "value",
                                        this.defaultML
                                      )}
                                      writingMode="horizontal"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "12px",
                                          color: "#6b7c93",
                                        } as any
                                      }
                                    ></Label>
                                  </VerticalStack>
                                </KCol>
                              </KRow>
                            </KPanel>
                          </KCol>
                          <KCol
                            key="317772"
                            id="317772"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={6}
                            xxl={6}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <KPanel
                              key="412735"
                              id="412735"
                              scrolling="hidden"
                              scrollRadius={false}
                              style={
                                {
                                  borderTopLeftRadius: 18,
                                  borderTopRightRadius: 18,
                                  borderBottomRightRadius: 18,
                                  borderBottomLeftRadius: 18,
                                  boxShadow: "0px 6px 16px 0px #d7dee8",
                                  backgroundColor: "#ffffff",
                                  paddingTop: 28,
                                  paddingRight: 24,
                                  paddingBottom: 28,
                                  paddingLeft: 24,
                                } as any
                              }
                            >
                              <KRow
                                key="393460"
                                id="393460"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="874149"
                                  id="874149"
                                  xs={8}
                                  sm={8}
                                  md={8}
                                  lg={8}
                                  xl={8}
                                  xxl={8}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-center",
                                    } as any
                                  }
                                >
                                  <Icon
                                    key="366773"
                                    id="366773"
                                    iconName="local_post_office"
                                    style={
                                      {
                                        borderTopLeftRadius: 14,
                                        borderTopRightRadius: 14,
                                        borderBottomRightRadius: 14,
                                        borderBottomLeftRadius: 14,
                                        backgroundColor: "#dff4ea",
                                        paddingTop: 10,
                                        paddingRight: 10,
                                        paddingBottom: 10,
                                        paddingLeft: 10,
                                        fontSize: "28px",
                                        color: "#14b86a",
                                      } as any
                                    }
                                  ></Icon>
                                </KCol>
                                <KCol
                                  key="514875"
                                  id="514875"
                                  xs={16}
                                  sm={16}
                                  md={16}
                                  lg={16}
                                  xl={16}
                                  xxl={16}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      alignItems: "center",
                                    } as any
                                  }
                                >
                                  <VerticalStack
                                    key="600796"
                                    id="600796"
                                    direction="vertical"
                                    size={2}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <Label
                                      key="844118"
                                      id="844118"
                                      value={
                                        this.state.OkunmamisBildirimSayisiGetir?.at?.(
                                          0
                                        )?.sayi ?? undefined
                                      }
                                      writingMode="horizontal"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Poppins",
                                          fontWeight: 700,
                                          fontSize: "18px",
                                          color: "#0f2340",
                                        } as any
                                      }
                                    ></Label>
                                    <Label
                                      key="942838"
                                      id="942838"
                                      value={ReactSystemFunctions.translate(
                                        this.ml,
                                        942838,
                                        "value",
                                        this.defaultML
                                      )}
                                      writingMode="horizontal"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "12px",
                                          color: "#6b7c93",
                                        } as any
                                      }
                                    ></Label>
                                  </VerticalStack>
                                </KCol>
                              </KRow>
                            </KPanel>
                          </KCol>
                          <KCol
                            key="290323"
                            id="290323"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={6}
                            xxl={6}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <KPanel
                              key="646430"
                              id="646430"
                              scrolling="hidden"
                              scrollRadius={false}
                              style={
                                {
                                  borderTopLeftRadius: 18,
                                  borderTopRightRadius: 18,
                                  borderBottomRightRadius: 18,
                                  borderBottomLeftRadius: 18,
                                  boxShadow: "0px 6px 16px 0px #d7dee8",
                                  backgroundColor: "#ffffff",
                                  paddingTop: 28,
                                  paddingRight: 24,
                                  paddingBottom: 28,
                                  paddingLeft: 24,
                                } as any
                              }
                            >
                              <KRow
                                key="352663"
                                id="352663"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="406464"
                                  id="406464"
                                  xs={8}
                                  sm={8}
                                  md={8}
                                  lg={8}
                                  xl={8}
                                  xxl={8}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-center",
                                    } as any
                                  }
                                >
                                  <Icon
                                    key="314137"
                                    id="314137"
                                    iconName="done"
                                    style={
                                      {
                                        borderTopLeftRadius: 14,
                                        borderTopRightRadius: 14,
                                        borderBottomRightRadius: 14,
                                        borderBottomLeftRadius: 14,
                                        backgroundColor: "#f1e9ff",
                                        paddingTop: 10,
                                        paddingRight: 10,
                                        paddingBottom: 10,
                                        paddingLeft: 10,
                                        fontSize: "28px",
                                        color: "#7157d8",
                                      } as any
                                    }
                                  ></Icon>
                                </KCol>
                                <KCol
                                  key="918686"
                                  id="918686"
                                  xs={16}
                                  sm={16}
                                  md={16}
                                  lg={16}
                                  xl={16}
                                  xxl={16}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      alignItems: "center",
                                    } as any
                                  }
                                >
                                  <VerticalStack
                                    key="339273"
                                    id="339273"
                                    direction="vertical"
                                    size={2}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <Label
                                      key="913133"
                                      id="913133"
                                      writingMode="horizontal"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Poppins",
                                          fontWeight: 700,
                                          fontSize: "18px",
                                          color: "#0f2340",
                                        } as any
                                      }
                                    ></Label>
                                    <Label
                                      key="936864"
                                      id="936864"
                                      value={ReactSystemFunctions.translate(
                                        this.ml,
                                        936864,
                                        "value",
                                        this.defaultML
                                      )}
                                      writingMode="horizontal"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "#6b7c93",
                                        } as any
                                      }
                                    ></Label>
                                  </VerticalStack>
                                </KCol>
                              </KRow>
                            </KPanel>
                          </KCol>
                          <KCol
                            key="867560"
                            id="867560"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={6}
                            xxl={6}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <KPanel
                              key="100518"
                              id="100518"
                              scrolling="hidden"
                              scrollRadius={false}
                              style={
                                {
                                  borderTopLeftRadius: 18,
                                  borderTopRightRadius: 18,
                                  borderBottomRightRadius: 18,
                                  borderBottomLeftRadius: 18,
                                  boxShadow: "0px 6px 16px 0px #d7dee8",
                                  backgroundColor: "#ffffff",
                                  paddingTop: 28,
                                  paddingRight: 24,
                                  paddingBottom: 28,
                                  paddingLeft: 24,
                                } as any
                              }
                            >
                              <KRow
                                key="910860"
                                id="910860"
                                align="top"
                                justify="start"
                                horizontalGutter={0}
                                verticalGutter={0}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                  } as any
                                }
                              >
                                <KCol
                                  key="625284"
                                  id="625284"
                                  xs={8}
                                  sm={8}
                                  md={8}
                                  lg={8}
                                  xl={8}
                                  xxl={8}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      alignItems: "center",
                                      textAlign: "-webkit-center",
                                    } as any
                                  }
                                >
                                  <Icon
                                    key="976831"
                                    id="976831"
                                    iconName="close"
                                    style={
                                      {
                                        borderTopLeftRadius: 14,
                                        borderTopRightRadius: 14,
                                        borderBottomRightRadius: 14,
                                        borderBottomLeftRadius: 14,
                                        backgroundColor: "#f9e9e7",
                                        paddingTop: 10,
                                        paddingRight: 10,
                                        paddingBottom: 10,
                                        paddingLeft: 10,
                                        fontSize: "28px",
                                        color: "#f29b38",
                                      } as any
                                    }
                                  ></Icon>
                                </KCol>
                                <KCol
                                  key="26615"
                                  id="26615"
                                  xs={16}
                                  sm={16}
                                  md={16}
                                  lg={16}
                                  xl={16}
                                  xxl={16}
                                  order={0}
                                  pull={0}
                                  push={0}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      alignItems: "center",
                                    } as any
                                  }
                                >
                                  <VerticalStack
                                    key="746620"
                                    id="746620"
                                    direction="vertical"
                                    size={2}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <Label
                                      key="260611"
                                      id="260611"
                                      writingMode="horizontal"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Poppins",
                                          fontWeight: 700,
                                          fontSize: "18px",
                                          color: "#0f2340",
                                        } as any
                                      }
                                    ></Label>
                                    <Label
                                      key="706845"
                                      id="706845"
                                      value={ReactSystemFunctions.translate(
                                        this.ml,
                                        706845,
                                        "value",
                                        this.defaultML
                                      )}
                                      writingMode="horizontal"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          alignItems: "center",
                                          textAlign: "-webkit-left",
                                          display: "inline",
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "12px",
                                          color: "#6b7c93",
                                        } as any
                                      }
                                    ></Label>
                                  </VerticalStack>
                                </KCol>
                              </KRow>
                            </KPanel>
                          </KCol>
                        </KRow>
                      </KCol>
                      <KCol
                        key="955177"
                        id="955177"
                        xs={24}
                        sm={24}
                        md={24}
                        lg={24}
                        xl={24}
                        xxl={24}
                        order={0}
                        pull={0}
                        push={0}
                        style={
                          {
                            borderTopLeftRadius: 12,
                            borderTopRightRadius: 12,
                            borderBottomRightRadius: 12,
                            borderBottomLeftRadius: 12,
                            borderStyle: "solid",
                            borderTopWidth: 0,
                            borderRightWidth: 0,
                            borderBottomWidth: 0,
                            borderLeftWidth: 0,
                            paddingTop: 8,
                            paddingRight: 8,
                            paddingBottom: 8,
                            paddingLeft: 8,
                            alignItems: "flex-start",
                            textAlign: "-webkit-left",
                          } as any
                        }
                      >
                        <KRow
                          key="11464"
                          id="11464"
                          align="top"
                          justify="start"
                          horizontalGutter={0}
                          verticalGutter={0}
                          style={
                            {
                              borderStyle: "solid",
                              borderTopWidth: 0,
                              borderRightWidth: 0,
                              borderBottomWidth: 0,
                              borderLeftWidth: 0,
                              paddingTop: 8,
                              paddingRight: 8,
                              paddingBottom: 8,
                              paddingLeft: 8,
                              alignItems: "flex-start",
                              textAlign: "-webkit-left",
                            } as any
                          }
                        >
                          <KCol
                            key="79178"
                            id="79178"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                            xl={24}
                            xxl={24}
                            order={0}
                            pull={0}
                            push={0}
                            style={
                              {
                                borderTopLeftRadius: 8,
                                borderTopRightRadius: 8,
                                borderBottomRightRadius: 8,
                                borderBottomLeftRadius: 8,
                                borderStyle: "solid",
                                borderTopWidth: 0,
                                borderRightWidth: 0,
                                borderBottomWidth: 0,
                                borderLeftWidth: 0,
                                backgroundColor: "rgba(255, 255, 255, 1)",
                                paddingTop: 8,
                                paddingRight: 8,
                                paddingBottom: 8,
                                paddingLeft: 8,
                                alignItems: "flex-start",
                                textAlign: "-webkit-left",
                              } as any
                            }
                          >
                            <Form.Item
                              className="kFormItem"
                              name="bildirimlistesi_560805_value"
                              noStyle
                            >
                              <KTab
                                key="560805"
                                id="560805"
                                onChange={(e?: any) => {
                                  if (e && e.stopPropagation)
                                    e.stopPropagation();
                                  this.BildirimListesiComponent_560805_onChange();
                                }}
                                type="line"
                                size="default"
                                tabPosition="top"
                                selectedTabColor="#0078FF"
                                justifiedTabTitles={false}
                                style={
                                  {
                                    borderStyle: "solid",
                                    borderTopWidth: 0,
                                    borderRightWidth: 0,
                                    borderBottomWidth: 0,
                                    borderLeftWidth: 0,
                                    paddingTop: 0,
                                    paddingRight: 0,
                                    paddingBottom: 0,
                                    paddingLeft: 0,
                                    alignItems: "center",
                                    textAlign: "-webkit-left",
                                    display: "inline",
                                    fontFamily: "Poppins",
                                    fontWeight: 500,
                                    fontSize: "12px",
                                    color: "rgba(68, 68, 68, 1)",
                                  } as any
                                }
                              >
                                <KTabItem
                                  key={728186}
                                  id="728186"
                                  onActive={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.BildirimListesiComponent_728186_onActive();
                                  }}
                                  tab={ReactSystemFunctions.translate(
                                    this.ml,
                                    728186,
                                    "tab",
                                    this.defaultML
                                  )}
                                  forceRender={false}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <KTable
                                    key="876858"
                                    id="876858"
                                    kuikaRef={
                                      this
                                        .bildirimlistesi_876858_value_kuikaTableRef
                                    }
                                    form={this.props.form}
                                    dataSource={this.state.BildirimleriGetir}
                                    size="middle"
                                    bordered={true}
                                    loading={false}
                                    rowKey="id"
                                    transformedOnMobileResolution={false}
                                    hideHeaderOnMobileResolution={true}
                                    showHeader={false}
                                    fixedHeader={false}
                                    tableWidthMode="fit"
                                    editable={false}
                                    editableAlwaysActive={false}
                                    insertRowActive={false}
                                    insertRowPosition="top"
                                    globalSearch={false}
                                    searchable={false}
                                    shouldSearchOnChange={true}
                                    searchDelay={200}
                                    sorter={false}
                                    filtering={false}
                                    resizableColumns={false}
                                    pagination={true}
                                    pageSize={10}
                                    showSizeChanger={false}
                                    paginationSelectedTextColor="#246eff"
                                    paginationUnselectedTextColor="#000"
                                    columnChooser={false}
                                    striped={false}
                                    stripedColor="#F5F7FA"
                                    rowHoverBgColor="#fafafa"
                                    showRowNumbers={false}
                                    showNoDataFound={true}
                                    nodatafoundmessage={ReactSystemFunctions.translate(
                                      this.ml,
                                      876858,
                                      "nodatafoundmessage",
                                      this.defaultML
                                    )}
                                    multiSelect={false}
                                    multiSelectScope="page"
                                    export={false}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <KTableHeader
                                      key="18595"
                                      id="18595"
                                      hideOnMobileResolution={false}
                                      textDirection="Default"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: 400,
                                          fontSize: "12px",
                                          color: "rgba(155, 155, 155, 1)",
                                          lineHeight: "20px",
                                        } as any
                                      }
                                    ></KTableHeader>
                                    <KTableRow
                                      key="53633"
                                      id="53633"
                                      hoverFontColor="red"
                                      hoverBgColor="#F5F5F5"
                                      style={
                                        {
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <KTableColumn
                                        key="118875"
                                        id="118875"
                                        title={ReactSystemFunctions.translate(
                                          this.ml,
                                          118875,
                                          "title",
                                          this.defaultML
                                        )}
                                        alwaysVisibleOnMobileResolution={false}
                                        hideFiltering={false}
                                        hideSorting={false}
                                        hideSearch={false}
                                        footerOptions="none"
                                        footerFontSize={14}
                                        footerFontColor="rgb(68, 68, 68)"
                                        excludeFromExport={false}
                                        footerFontWeight="Regular"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="625342"
                                          id="625342"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="244028"
                                            id="244028"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                              } as any
                                            }
                                          >
                                            <KPanel
                                              key="900740"
                                              id="900740"
                                              scrolling="hidden"
                                              scrollRadius={false}
                                              style={
                                                {
                                                  borderTopLeftRadius: 16,
                                                  borderTopRightRadius: 16,
                                                  borderBottomRightRadius: 16,
                                                  borderBottomLeftRadius: 16,
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  backgroundColor:
                                                    "rgba(244, 248, 251, 1)",
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="878629"
                                                id="878629"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="53595"
                                                  id="53595"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={20}
                                                  xxl={20}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                    } as any
                                                  }
                                                >
                                                  <KRow
                                                    key="982158"
                                                    id="982158"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="832161"
                                                      id="832161"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={2}
                                                      xxl={2}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 8,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                        } as any
                                                      }
                                                    >
                                                      <Icon
                                                        key="611858"
                                                        id="611858"
                                                        visibility={
                                                          this.state
                                                            .isComp611858Visible
                                                        }
                                                        visibilityCondition={(
                                                          rowData: object
                                                        ) =>
                                                          ReactSystemFunctions.isEqualTo(
                                                            rowData.okundu,
                                                            "true"
                                                          )
                                                        }
                                                        iconName="local_post_office"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 14,
                                                            borderTopRightRadius: 14,
                                                            borderBottomRightRadius: 14,
                                                            borderBottomLeftRadius: 14,
                                                            backgroundColor:
                                                              "#dff4ea",
                                                            paddingTop: 10,
                                                            paddingRight: 10,
                                                            paddingBottom: 10,
                                                            paddingLeft: 10,
                                                            fontSize: "28px",
                                                            color: "#14b86a",
                                                          } as any
                                                        }
                                                      ></Icon>
                                                      <Icon
                                                        key="644882"
                                                        id="644882"
                                                        visibility={
                                                          this.state
                                                            .isComp644882Visible
                                                        }
                                                        visibilityCondition={(
                                                          rowData: object
                                                        ) =>
                                                          ReactSystemFunctions.isEqualTo(
                                                            rowData.okundu,
                                                            "false"
                                                          )
                                                        }
                                                        iconName="hourglass_top"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 14,
                                                            borderTopRightRadius: 14,
                                                            borderBottomRightRadius: 14,
                                                            borderBottomLeftRadius: 14,
                                                            backgroundColor:
                                                              "#f9e9e7",
                                                            paddingTop: 10,
                                                            paddingRight: 10,
                                                            paddingBottom: 10,
                                                            paddingLeft: 10,
                                                            fontSize: "28px",
                                                            color: "#f29b38",
                                                          } as any
                                                        }
                                                      ></Icon>
                                                    </KCol>
                                                    <KCol
                                                      key="541853"
                                                      id="541853"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={22}
                                                      xxl={22}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 8,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-left",
                                                        } as any
                                                      }
                                                    >
                                                      <VerticalStack
                                                        key="654139"
                                                        id="654139"
                                                        direction="vertical"
                                                        size={2}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <HorizontalStack
                                                          key="46380"
                                                          id="46380"
                                                          direction="horizontal"
                                                          size={12}
                                                          overflowX="auto"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <Label
                                                            key="532903"
                                                            id="532903"
                                                            value="[datafield:baslik]"
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "12px",
                                                              } as any
                                                            }
                                                          ></Label>
                                                        </HorizontalStack>
                                                        <HorizontalStack
                                                          key="225965"
                                                          id="225965"
                                                          direction="horizontal"
                                                          size={12}
                                                          overflowX="auto"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <Label
                                                            key="556242"
                                                            id="556242"
                                                            value="[datafield:mesaj]"
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 400,
                                                                fontSize:
                                                                  "12px",
                                                              } as any
                                                            }
                                                          ></Label>
                                                        </HorizontalStack>
                                                        <HorizontalStack
                                                          key="171244"
                                                          id="171244"
                                                          direction="horizontal"
                                                          size={2}
                                                          overflowX="auto"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <Icon
                                                            key="256804"
                                                            id="256804"
                                                            iconName="person"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(217, 217, 217, 1)",
                                                                letterSpacing:
                                                                  "1px",
                                                              } as any
                                                            }
                                                          ></Icon>
                                                          <Label
                                                            key="433380"
                                                            id="433380"
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 300,
                                                                fontSize:
                                                                  "10px",
                                                                color:
                                                                  "rgba(140, 140, 140, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                          <Label
                                                            key="735816"
                                                            id="735816"
                                                            value={ReactSystemFunctions.translate(
                                                              this.ml,
                                                              735816,
                                                              "value",
                                                              this.defaultML
                                                            )}
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 600,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(255, 255, 255, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                          <Icon
                                                            key="993906"
                                                            id="993906"
                                                            iconName="business"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(217, 217, 217, 1)",
                                                                letterSpacing:
                                                                  "1px",
                                                              } as any
                                                            }
                                                          ></Icon>
                                                          <Label
                                                            key="147683"
                                                            id="147683"
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 300,
                                                                fontSize:
                                                                  "10px",
                                                                color:
                                                                  "rgba(140, 140, 140, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                          <Label
                                                            key="294355"
                                                            id="294355"
                                                            value={ReactSystemFunctions.translate(
                                                              this.ml,
                                                              294355,
                                                              "value",
                                                              this.defaultML
                                                            )}
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 600,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(255, 255, 255, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                          <Icon
                                                            key="529291"
                                                            id="529291"
                                                            iconName="calendar_month"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(217, 217, 217, 1)",
                                                                letterSpacing:
                                                                  "1px",
                                                              } as any
                                                            }
                                                          ></Icon>
                                                          <HorizontalStack
                                                            key="778237"
                                                            id="778237"
                                                            direction="horizontal"
                                                            size={0}
                                                            overflowX="auto"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "14px",
                                                                color:
                                                                  "rgba(68, 68, 68, 1)",
                                                              } as any
                                                            }
                                                          >
                                                            <Label
                                                              key="297572"
                                                              id="297572"
                                                              value="[datafield:projeAdi]"
                                                              writingMode="horizontal"
                                                              style={
                                                                {
                                                                  borderStyle:
                                                                    "solid",
                                                                  borderTopWidth: 0,
                                                                  borderRightWidth: 0,
                                                                  borderBottomWidth: 0,
                                                                  borderLeftWidth: 0,
                                                                  paddingTop: 0,
                                                                  paddingRight: 0,
                                                                  paddingBottom: 0,
                                                                  paddingLeft: 0,
                                                                  alignItems:
                                                                    "center",
                                                                  textAlign:
                                                                    "-webkit-left",
                                                                  display:
                                                                    "inline",
                                                                  fontWeight: 300,
                                                                  fontSize:
                                                                    "10px",
                                                                  color:
                                                                    "rgba(140, 140, 140, 1)",
                                                                } as any
                                                              }
                                                            ></Label>
                                                            <Label
                                                              key="394820"
                                                              id="394820"
                                                              value={ReactSystemFunctions.translate(
                                                                this.ml,
                                                                394820,
                                                                "value",
                                                                this.defaultML
                                                              )}
                                                              writingMode="horizontal"
                                                              style={
                                                                {
                                                                  borderStyle:
                                                                    "solid",
                                                                  borderTopWidth: 0,
                                                                  borderRightWidth: 0,
                                                                  borderBottomWidth: 0,
                                                                  borderLeftWidth: 0,
                                                                  paddingTop: 0,
                                                                  paddingRight: 0,
                                                                  paddingBottom: 0,
                                                                  paddingLeft: 0,
                                                                  alignItems:
                                                                    "center",
                                                                  textAlign:
                                                                    "-webkit-left",
                                                                  display:
                                                                    "inline",
                                                                  fontWeight: 300,
                                                                  fontSize:
                                                                    "10px",
                                                                  color:
                                                                    "rgba(255, 255, 255, 1)",
                                                                } as any
                                                              }
                                                            ></Label>
                                                          </HorizontalStack>
                                                        </HorizontalStack>
                                                      </VerticalStack>
                                                    </KCol>
                                                  </KRow>
                                                </KCol>
                                                <KCol
                                                  key="956697"
                                                  id="956697"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={4}
                                                  xxl={4}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                    } as any
                                                  }
                                                >
                                                  <VerticalStack
                                                    key="389917"
                                                    id="389917"
                                                    direction="vertical"
                                                    size={5}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="736330"
                                                      id="736330"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        736330,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontWeight: 400,
                                                          fontSize: "10px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <HorizontalStack
                                                      key="978554"
                                                      id="978554"
                                                      direction="horizontal"
                                                      size={5}
                                                      overflowX="auto"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Icon
                                                        key="550265"
                                                        id="550265"
                                                        iconName="link"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 4,
                                                            borderTopRightRadius: 4,
                                                            borderBottomRightRadius: 4,
                                                            borderBottomLeftRadius: 4,
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            backgroundColor:
                                                              "rgba(255, 255, 255, 1)",
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "12px",
                                                            color:
                                                              "rgba(155, 155, 155, 1)",
                                                            letterSpacing:
                                                              "1px",
                                                          } as any
                                                        }
                                                      ></Icon>
                                                      <Icon
                                                        key="918323"
                                                        id="918323"
                                                        iconName="delete_outline"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 4,
                                                            borderTopRightRadius: 4,
                                                            borderBottomRightRadius: 4,
                                                            borderBottomLeftRadius: 4,
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            backgroundColor:
                                                              "rgba(255, 255, 255, 1)",
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "12px",
                                                            color:
                                                              "rgba(155, 155, 155, 1)",
                                                            letterSpacing:
                                                              "1px",
                                                          } as any
                                                        }
                                                      ></Icon>
                                                    </HorizontalStack>
                                                  </VerticalStack>
                                                </KCol>
                                              </KRow>
                                            </KPanel>
                                          </KCol>
                                        </KRow>
                                      </KTableColumn>
                                    </KTableRow>
                                  </KTable>
                                </KTabItem>
                                <KTabItem
                                  key={48514}
                                  id="48514"
                                  onActive={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.BildirimListesiComponent_48514_onActive();
                                  }}
                                  tab={ReactSystemFunctions.translate(
                                    this.ml,
                                    48514,
                                    "tab",
                                    this.defaultML
                                  )}
                                  forceRender={false}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <KTable
                                    key="861093"
                                    id="861093"
                                    kuikaRef={
                                      this
                                        .bildirimlistesi_861093_value_kuikaTableRef
                                    }
                                    form={this.props.form}
                                    dataSource={this.state.BildirimleriGetir}
                                    size="middle"
                                    bordered={true}
                                    loading={false}
                                    rowKey="id"
                                    transformedOnMobileResolution={false}
                                    hideHeaderOnMobileResolution={true}
                                    showHeader={false}
                                    fixedHeader={false}
                                    tableWidthMode="fit"
                                    editable={false}
                                    editableAlwaysActive={false}
                                    insertRowActive={false}
                                    insertRowPosition="top"
                                    globalSearch={false}
                                    searchable={false}
                                    shouldSearchOnChange={true}
                                    searchDelay={200}
                                    sorter={false}
                                    filtering={false}
                                    resizableColumns={false}
                                    pagination={true}
                                    pageSize={10}
                                    showSizeChanger={false}
                                    paginationSelectedTextColor="#246eff"
                                    paginationUnselectedTextColor="#000"
                                    columnChooser={false}
                                    striped={false}
                                    stripedColor="#F5F7FA"
                                    rowHoverBgColor="#fafafa"
                                    showRowNumbers={false}
                                    showNoDataFound={true}
                                    nodatafoundmessage={ReactSystemFunctions.translate(
                                      this.ml,
                                      861093,
                                      "nodatafoundmessage",
                                      this.defaultML
                                    )}
                                    multiSelect={false}
                                    multiSelectScope="page"
                                    export={false}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <KTableHeader
                                      key="681130"
                                      id="681130"
                                      hideOnMobileResolution={false}
                                      textDirection="Default"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: 400,
                                          fontSize: "12px",
                                          color: "rgba(155, 155, 155, 1)",
                                          lineHeight: "20px",
                                        } as any
                                      }
                                    ></KTableHeader>
                                    <KTableRow
                                      key="422302"
                                      id="422302"
                                      hoverFontColor="red"
                                      hoverBgColor="#F5F5F5"
                                      style={
                                        {
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <KTableColumn
                                        key="830332"
                                        id="830332"
                                        title={ReactSystemFunctions.translate(
                                          this.ml,
                                          830332,
                                          "title",
                                          this.defaultML
                                        )}
                                        alwaysVisibleOnMobileResolution={false}
                                        hideFiltering={false}
                                        hideSorting={false}
                                        hideSearch={false}
                                        footerOptions="none"
                                        footerFontSize={14}
                                        footerFontColor="rgb(68, 68, 68)"
                                        excludeFromExport={false}
                                        footerFontWeight="Regular"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="995093"
                                          id="995093"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="61784"
                                            id="61784"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                              } as any
                                            }
                                          >
                                            <KPanel
                                              key="353005"
                                              id="353005"
                                              scrolling="hidden"
                                              scrollRadius={false}
                                              style={
                                                {
                                                  borderTopLeftRadius: 16,
                                                  borderTopRightRadius: 16,
                                                  borderBottomRightRadius: 16,
                                                  borderBottomLeftRadius: 16,
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  backgroundColor:
                                                    "rgba(244, 248, 251, 1)",
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="668167"
                                                id="668167"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="36455"
                                                  id="36455"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={20}
                                                  xxl={20}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                    } as any
                                                  }
                                                >
                                                  <KRow
                                                    key="625869"
                                                    id="625869"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="724657"
                                                      id="724657"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={2}
                                                      xxl={2}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 8,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                        } as any
                                                      }
                                                    >
                                                      <Icon
                                                        key="618074"
                                                        id="618074"
                                                        iconName="local_post_office"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 14,
                                                            borderTopRightRadius: 14,
                                                            borderBottomRightRadius: 14,
                                                            borderBottomLeftRadius: 14,
                                                            backgroundColor:
                                                              "#dff4ea",
                                                            paddingTop: 10,
                                                            paddingRight: 10,
                                                            paddingBottom: 10,
                                                            paddingLeft: 10,
                                                            fontSize: "28px",
                                                            color: "#14b86a",
                                                          } as any
                                                        }
                                                      ></Icon>
                                                    </KCol>
                                                    <KCol
                                                      key="2398"
                                                      id="2398"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={22}
                                                      xxl={22}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 8,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-left",
                                                        } as any
                                                      }
                                                    >
                                                      <VerticalStack
                                                        key="594639"
                                                        id="594639"
                                                        direction="vertical"
                                                        size={2}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <HorizontalStack
                                                          key="568069"
                                                          id="568069"
                                                          direction="horizontal"
                                                          size={12}
                                                          overflowX="auto"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <Label
                                                            key="997566"
                                                            id="997566"
                                                            value="[datafield:baslik]"
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "12px",
                                                              } as any
                                                            }
                                                          ></Label>
                                                        </HorizontalStack>
                                                        <HorizontalStack
                                                          key="47396"
                                                          id="47396"
                                                          direction="horizontal"
                                                          size={12}
                                                          overflowX="auto"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <Label
                                                            key="791873"
                                                            id="791873"
                                                            value="[datafield:mesaj]"
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 400,
                                                                fontSize:
                                                                  "12px",
                                                              } as any
                                                            }
                                                          ></Label>
                                                        </HorizontalStack>
                                                        <HorizontalStack
                                                          key="846968"
                                                          id="846968"
                                                          direction="horizontal"
                                                          size={2}
                                                          overflowX="auto"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <Icon
                                                            key="804697"
                                                            id="804697"
                                                            iconName="person"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(217, 217, 217, 1)",
                                                                letterSpacing:
                                                                  "1px",
                                                              } as any
                                                            }
                                                          ></Icon>
                                                          <Label
                                                            key="470665"
                                                            id="470665"
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 300,
                                                                fontSize:
                                                                  "10px",
                                                                color:
                                                                  "rgba(140, 140, 140, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                          <Label
                                                            key="234551"
                                                            id="234551"
                                                            value={ReactSystemFunctions.translate(
                                                              this.ml,
                                                              234551,
                                                              "value",
                                                              this.defaultML
                                                            )}
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 600,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(255, 255, 255, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                          <Icon
                                                            key="336667"
                                                            id="336667"
                                                            iconName="business"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(217, 217, 217, 1)",
                                                                letterSpacing:
                                                                  "1px",
                                                              } as any
                                                            }
                                                          ></Icon>
                                                          <Label
                                                            key="905848"
                                                            id="905848"
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 300,
                                                                fontSize:
                                                                  "10px",
                                                                color:
                                                                  "rgba(140, 140, 140, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                          <Label
                                                            key="166299"
                                                            id="166299"
                                                            value={ReactSystemFunctions.translate(
                                                              this.ml,
                                                              166299,
                                                              "value",
                                                              this.defaultML
                                                            )}
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 600,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(255, 255, 255, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                          <Icon
                                                            key="127833"
                                                            id="127833"
                                                            iconName="calendar_month"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(217, 217, 217, 1)",
                                                                letterSpacing:
                                                                  "1px",
                                                              } as any
                                                            }
                                                          ></Icon>
                                                          <HorizontalStack
                                                            key="237607"
                                                            id="237607"
                                                            direction="horizontal"
                                                            size={0}
                                                            overflowX="auto"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "14px",
                                                                color:
                                                                  "rgba(68, 68, 68, 1)",
                                                              } as any
                                                            }
                                                          >
                                                            <Label
                                                              key="986428"
                                                              id="986428"
                                                              value="[datafield:projeAdi]"
                                                              writingMode="horizontal"
                                                              style={
                                                                {
                                                                  borderStyle:
                                                                    "solid",
                                                                  borderTopWidth: 0,
                                                                  borderRightWidth: 0,
                                                                  borderBottomWidth: 0,
                                                                  borderLeftWidth: 0,
                                                                  paddingTop: 0,
                                                                  paddingRight: 0,
                                                                  paddingBottom: 0,
                                                                  paddingLeft: 0,
                                                                  alignItems:
                                                                    "center",
                                                                  textAlign:
                                                                    "-webkit-left",
                                                                  display:
                                                                    "inline",
                                                                  fontWeight: 300,
                                                                  fontSize:
                                                                    "10px",
                                                                  color:
                                                                    "rgba(140, 140, 140, 1)",
                                                                } as any
                                                              }
                                                            ></Label>
                                                            <Label
                                                              key="559087"
                                                              id="559087"
                                                              value={ReactSystemFunctions.translate(
                                                                this.ml,
                                                                559087,
                                                                "value",
                                                                this.defaultML
                                                              )}
                                                              writingMode="horizontal"
                                                              style={
                                                                {
                                                                  borderStyle:
                                                                    "solid",
                                                                  borderTopWidth: 0,
                                                                  borderRightWidth: 0,
                                                                  borderBottomWidth: 0,
                                                                  borderLeftWidth: 0,
                                                                  paddingTop: 0,
                                                                  paddingRight: 0,
                                                                  paddingBottom: 0,
                                                                  paddingLeft: 0,
                                                                  alignItems:
                                                                    "center",
                                                                  textAlign:
                                                                    "-webkit-left",
                                                                  display:
                                                                    "inline",
                                                                  fontWeight: 300,
                                                                  fontSize:
                                                                    "10px",
                                                                  color:
                                                                    "rgba(255, 255, 255, 1)",
                                                                } as any
                                                              }
                                                            ></Label>
                                                          </HorizontalStack>
                                                        </HorizontalStack>
                                                      </VerticalStack>
                                                    </KCol>
                                                  </KRow>
                                                </KCol>
                                                <KCol
                                                  key="112034"
                                                  id="112034"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={4}
                                                  xxl={4}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                    } as any
                                                  }
                                                >
                                                  <VerticalStack
                                                    key="766526"
                                                    id="766526"
                                                    direction="vertical"
                                                    size={5}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="130156"
                                                      id="130156"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        130156,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontWeight: 400,
                                                          fontSize: "10px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <HorizontalStack
                                                      key="812763"
                                                      id="812763"
                                                      direction="horizontal"
                                                      size={5}
                                                      overflowX="auto"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Icon
                                                        key="638621"
                                                        id="638621"
                                                        iconName="link"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 4,
                                                            borderTopRightRadius: 4,
                                                            borderBottomRightRadius: 4,
                                                            borderBottomLeftRadius: 4,
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            backgroundColor:
                                                              "rgba(255, 255, 255, 1)",
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "12px",
                                                            color:
                                                              "rgba(155, 155, 155, 1)",
                                                            letterSpacing:
                                                              "1px",
                                                          } as any
                                                        }
                                                      ></Icon>
                                                      <Icon
                                                        key="578513"
                                                        id="578513"
                                                        iconName="delete_outline"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 4,
                                                            borderTopRightRadius: 4,
                                                            borderBottomRightRadius: 4,
                                                            borderBottomLeftRadius: 4,
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            backgroundColor:
                                                              "rgba(255, 255, 255, 1)",
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "12px",
                                                            color:
                                                              "rgba(155, 155, 155, 1)",
                                                            letterSpacing:
                                                              "1px",
                                                          } as any
                                                        }
                                                      ></Icon>
                                                    </HorizontalStack>
                                                  </VerticalStack>
                                                </KCol>
                                              </KRow>
                                            </KPanel>
                                          </KCol>
                                        </KRow>
                                      </KTableColumn>
                                    </KTableRow>
                                  </KTable>
                                </KTabItem>
                                <KTabItem
                                  key={90266}
                                  id="90266"
                                  onActive={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.BildirimListesiComponent_90266_onActive();
                                  }}
                                  tab={ReactSystemFunctions.translate(
                                    this.ml,
                                    90266,
                                    "tab",
                                    this.defaultML
                                  )}
                                  forceRender={false}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <KTable
                                    key="277585"
                                    id="277585"
                                    kuikaRef={
                                      this
                                        .bildirimlistesi_277585_value_kuikaTableRef
                                    }
                                    form={this.props.form}
                                    dataSource={this.state.BildirimleriGetir}
                                    size="middle"
                                    bordered={true}
                                    loading={false}
                                    rowKey="id"
                                    transformedOnMobileResolution={false}
                                    hideHeaderOnMobileResolution={true}
                                    showHeader={false}
                                    fixedHeader={false}
                                    tableWidthMode="fit"
                                    editable={false}
                                    editableAlwaysActive={false}
                                    insertRowActive={false}
                                    insertRowPosition="top"
                                    globalSearch={false}
                                    searchable={false}
                                    shouldSearchOnChange={true}
                                    searchDelay={200}
                                    sorter={false}
                                    filtering={false}
                                    resizableColumns={false}
                                    pagination={true}
                                    pageSize={10}
                                    showSizeChanger={false}
                                    paginationSelectedTextColor="#246eff"
                                    paginationUnselectedTextColor="#000"
                                    columnChooser={false}
                                    striped={false}
                                    stripedColor="#F5F7FA"
                                    rowHoverBgColor="#fafafa"
                                    showRowNumbers={false}
                                    showNoDataFound={true}
                                    nodatafoundmessage={ReactSystemFunctions.translate(
                                      this.ml,
                                      277585,
                                      "nodatafoundmessage",
                                      this.defaultML
                                    )}
                                    multiSelect={false}
                                    multiSelectScope="page"
                                    export={false}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <KTableHeader
                                      key="23444"
                                      id="23444"
                                      hideOnMobileResolution={false}
                                      textDirection="Default"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: 400,
                                          fontSize: "12px",
                                          color: "rgba(155, 155, 155, 1)",
                                          lineHeight: "20px",
                                        } as any
                                      }
                                    ></KTableHeader>
                                    <KTableRow
                                      key="228430"
                                      id="228430"
                                      hoverFontColor="red"
                                      hoverBgColor="#F5F5F5"
                                      style={
                                        {
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <KTableColumn
                                        key="329569"
                                        id="329569"
                                        title={ReactSystemFunctions.translate(
                                          this.ml,
                                          329569,
                                          "title",
                                          this.defaultML
                                        )}
                                        alwaysVisibleOnMobileResolution={false}
                                        hideFiltering={false}
                                        hideSorting={false}
                                        hideSearch={false}
                                        footerOptions="none"
                                        footerFontSize={14}
                                        footerFontColor="rgb(68, 68, 68)"
                                        excludeFromExport={false}
                                        footerFontWeight="Regular"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="860820"
                                          id="860820"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="584180"
                                            id="584180"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                              } as any
                                            }
                                          >
                                            <KPanel
                                              key="83849"
                                              id="83849"
                                              scrolling="hidden"
                                              scrollRadius={false}
                                              style={
                                                {
                                                  borderTopLeftRadius: 16,
                                                  borderTopRightRadius: 16,
                                                  borderBottomRightRadius: 16,
                                                  borderBottomLeftRadius: 16,
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  backgroundColor:
                                                    "rgba(244, 248, 251, 1)",
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="236962"
                                                id="236962"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="247515"
                                                  id="247515"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={20}
                                                  xxl={20}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                    } as any
                                                  }
                                                >
                                                  <KRow
                                                    key="305148"
                                                    id="305148"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="923406"
                                                      id="923406"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={2}
                                                      xxl={2}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 8,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                        } as any
                                                      }
                                                    >
                                                      <Icon
                                                        key="118762"
                                                        id="118762"
                                                        iconName="local_post_office"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 14,
                                                            borderTopRightRadius: 14,
                                                            borderBottomRightRadius: 14,
                                                            borderBottomLeftRadius: 14,
                                                            backgroundColor:
                                                              "#dff4ea",
                                                            paddingTop: 10,
                                                            paddingRight: 10,
                                                            paddingBottom: 10,
                                                            paddingLeft: 10,
                                                            fontSize: "28px",
                                                            color: "#14b86a",
                                                          } as any
                                                        }
                                                      ></Icon>
                                                    </KCol>
                                                    <KCol
                                                      key="150760"
                                                      id="150760"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={22}
                                                      xxl={22}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 8,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-left",
                                                        } as any
                                                      }
                                                    >
                                                      <VerticalStack
                                                        key="832591"
                                                        id="832591"
                                                        direction="vertical"
                                                        size={2}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <HorizontalStack
                                                          key="868290"
                                                          id="868290"
                                                          direction="horizontal"
                                                          size={12}
                                                          overflowX="auto"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <Label
                                                            key="775183"
                                                            id="775183"
                                                            value="[datafield:baslik]"
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "12px",
                                                              } as any
                                                            }
                                                          ></Label>
                                                        </HorizontalStack>
                                                        <HorizontalStack
                                                          key="902395"
                                                          id="902395"
                                                          direction="horizontal"
                                                          size={12}
                                                          overflowX="auto"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <Label
                                                            key="42616"
                                                            id="42616"
                                                            value="[datafield:mesaj]"
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 400,
                                                                fontSize:
                                                                  "12px",
                                                              } as any
                                                            }
                                                          ></Label>
                                                        </HorizontalStack>
                                                        <HorizontalStack
                                                          key="350886"
                                                          id="350886"
                                                          direction="horizontal"
                                                          size={2}
                                                          overflowX="auto"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <Icon
                                                            key="960150"
                                                            id="960150"
                                                            iconName="person"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(217, 217, 217, 1)",
                                                                letterSpacing:
                                                                  "1px",
                                                              } as any
                                                            }
                                                          ></Icon>
                                                          <Label
                                                            key="642839"
                                                            id="642839"
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 300,
                                                                fontSize:
                                                                  "10px",
                                                                color:
                                                                  "rgba(140, 140, 140, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                          <Label
                                                            key="105973"
                                                            id="105973"
                                                            value={ReactSystemFunctions.translate(
                                                              this.ml,
                                                              105973,
                                                              "value",
                                                              this.defaultML
                                                            )}
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 600,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(255, 255, 255, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                          <Icon
                                                            key="106026"
                                                            id="106026"
                                                            iconName="business"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(217, 217, 217, 1)",
                                                                letterSpacing:
                                                                  "1px",
                                                              } as any
                                                            }
                                                          ></Icon>
                                                          <Label
                                                            key="250759"
                                                            id="250759"
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 300,
                                                                fontSize:
                                                                  "10px",
                                                                color:
                                                                  "rgba(140, 140, 140, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                          <Label
                                                            key="316650"
                                                            id="316650"
                                                            value={ReactSystemFunctions.translate(
                                                              this.ml,
                                                              316650,
                                                              "value",
                                                              this.defaultML
                                                            )}
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 600,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(255, 255, 255, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                          <Icon
                                                            key="478380"
                                                            id="478380"
                                                            iconName="calendar_month"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(217, 217, 217, 1)",
                                                                letterSpacing:
                                                                  "1px",
                                                              } as any
                                                            }
                                                          ></Icon>
                                                          <HorizontalStack
                                                            key="857407"
                                                            id="857407"
                                                            direction="horizontal"
                                                            size={0}
                                                            overflowX="auto"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "14px",
                                                                color:
                                                                  "rgba(68, 68, 68, 1)",
                                                              } as any
                                                            }
                                                          >
                                                            <Label
                                                              key="221591"
                                                              id="221591"
                                                              value="[datafield:projeAdi]"
                                                              writingMode="horizontal"
                                                              style={
                                                                {
                                                                  borderStyle:
                                                                    "solid",
                                                                  borderTopWidth: 0,
                                                                  borderRightWidth: 0,
                                                                  borderBottomWidth: 0,
                                                                  borderLeftWidth: 0,
                                                                  paddingTop: 0,
                                                                  paddingRight: 0,
                                                                  paddingBottom: 0,
                                                                  paddingLeft: 0,
                                                                  alignItems:
                                                                    "center",
                                                                  textAlign:
                                                                    "-webkit-left",
                                                                  display:
                                                                    "inline",
                                                                  fontWeight: 300,
                                                                  fontSize:
                                                                    "10px",
                                                                  color:
                                                                    "rgba(140, 140, 140, 1)",
                                                                } as any
                                                              }
                                                            ></Label>
                                                            <Label
                                                              key="617630"
                                                              id="617630"
                                                              value={ReactSystemFunctions.translate(
                                                                this.ml,
                                                                617630,
                                                                "value",
                                                                this.defaultML
                                                              )}
                                                              writingMode="horizontal"
                                                              style={
                                                                {
                                                                  borderStyle:
                                                                    "solid",
                                                                  borderTopWidth: 0,
                                                                  borderRightWidth: 0,
                                                                  borderBottomWidth: 0,
                                                                  borderLeftWidth: 0,
                                                                  paddingTop: 0,
                                                                  paddingRight: 0,
                                                                  paddingBottom: 0,
                                                                  paddingLeft: 0,
                                                                  alignItems:
                                                                    "center",
                                                                  textAlign:
                                                                    "-webkit-left",
                                                                  display:
                                                                    "inline",
                                                                  fontWeight: 300,
                                                                  fontSize:
                                                                    "10px",
                                                                  color:
                                                                    "rgba(255, 255, 255, 1)",
                                                                } as any
                                                              }
                                                            ></Label>
                                                          </HorizontalStack>
                                                        </HorizontalStack>
                                                      </VerticalStack>
                                                    </KCol>
                                                  </KRow>
                                                </KCol>
                                                <KCol
                                                  key="603733"
                                                  id="603733"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={4}
                                                  xxl={4}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                    } as any
                                                  }
                                                >
                                                  <VerticalStack
                                                    key="284055"
                                                    id="284055"
                                                    direction="vertical"
                                                    size={5}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="9250"
                                                      id="9250"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        9250,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontWeight: 400,
                                                          fontSize: "10px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <HorizontalStack
                                                      key="798146"
                                                      id="798146"
                                                      direction="horizontal"
                                                      size={5}
                                                      overflowX="auto"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Icon
                                                        key="561777"
                                                        id="561777"
                                                        iconName="link"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 4,
                                                            borderTopRightRadius: 4,
                                                            borderBottomRightRadius: 4,
                                                            borderBottomLeftRadius: 4,
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            backgroundColor:
                                                              "rgba(255, 255, 255, 1)",
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "12px",
                                                            color:
                                                              "rgba(155, 155, 155, 1)",
                                                            letterSpacing:
                                                              "1px",
                                                          } as any
                                                        }
                                                      ></Icon>
                                                      <Icon
                                                        key="806908"
                                                        id="806908"
                                                        iconName="delete_outline"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 4,
                                                            borderTopRightRadius: 4,
                                                            borderBottomRightRadius: 4,
                                                            borderBottomLeftRadius: 4,
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            backgroundColor:
                                                              "rgba(255, 255, 255, 1)",
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "12px",
                                                            color:
                                                              "rgba(155, 155, 155, 1)",
                                                            letterSpacing:
                                                              "1px",
                                                          } as any
                                                        }
                                                      ></Icon>
                                                    </HorizontalStack>
                                                  </VerticalStack>
                                                </KCol>
                                              </KRow>
                                            </KPanel>
                                          </KCol>
                                        </KRow>
                                      </KTableColumn>
                                    </KTableRow>
                                  </KTable>
                                </KTabItem>
                                <KTabItem
                                  key={242860}
                                  id="242860"
                                  onActive={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.BildirimListesiComponent_242860_onActive();
                                  }}
                                  tab={ReactSystemFunctions.translate(
                                    this.ml,
                                    242860,
                                    "tab",
                                    this.defaultML
                                  )}
                                  forceRender={false}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <KTable
                                    key="274723"
                                    id="274723"
                                    kuikaRef={
                                      this
                                        .bildirimlistesi_274723_value_kuikaTableRef
                                    }
                                    form={this.props.form}
                                    dataSource={this.state.BildirimleriGetir}
                                    size="middle"
                                    bordered={true}
                                    loading={false}
                                    rowKey="id"
                                    transformedOnMobileResolution={false}
                                    hideHeaderOnMobileResolution={true}
                                    showHeader={false}
                                    fixedHeader={false}
                                    tableWidthMode="fit"
                                    editable={false}
                                    editableAlwaysActive={false}
                                    insertRowActive={false}
                                    insertRowPosition="top"
                                    globalSearch={false}
                                    searchable={false}
                                    shouldSearchOnChange={true}
                                    searchDelay={200}
                                    sorter={false}
                                    filtering={false}
                                    resizableColumns={false}
                                    pagination={true}
                                    pageSize={10}
                                    showSizeChanger={false}
                                    paginationSelectedTextColor="#246eff"
                                    paginationUnselectedTextColor="#000"
                                    columnChooser={false}
                                    striped={false}
                                    stripedColor="#F5F7FA"
                                    rowHoverBgColor="#fafafa"
                                    showRowNumbers={false}
                                    showNoDataFound={true}
                                    nodatafoundmessage={ReactSystemFunctions.translate(
                                      this.ml,
                                      274723,
                                      "nodatafoundmessage",
                                      this.defaultML
                                    )}
                                    multiSelect={false}
                                    multiSelectScope="page"
                                    export={false}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <KTableHeader
                                      key="47834"
                                      id="47834"
                                      hideOnMobileResolution={false}
                                      textDirection="Default"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: 400,
                                          fontSize: "12px",
                                          color: "rgba(155, 155, 155, 1)",
                                          lineHeight: "20px",
                                        } as any
                                      }
                                    ></KTableHeader>
                                    <KTableRow
                                      key="15289"
                                      id="15289"
                                      hoverFontColor="red"
                                      hoverBgColor="#F5F5F5"
                                      style={
                                        {
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <KTableColumn
                                        key="618556"
                                        id="618556"
                                        title={ReactSystemFunctions.translate(
                                          this.ml,
                                          618556,
                                          "title",
                                          this.defaultML
                                        )}
                                        alwaysVisibleOnMobileResolution={false}
                                        hideFiltering={false}
                                        hideSorting={false}
                                        hideSearch={false}
                                        footerOptions="none"
                                        footerFontSize={14}
                                        footerFontColor="rgb(68, 68, 68)"
                                        excludeFromExport={false}
                                        footerFontWeight="Regular"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="833814"
                                          id="833814"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="850000"
                                            id="850000"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                              } as any
                                            }
                                          >
                                            <KPanel
                                              key="795361"
                                              id="795361"
                                              scrolling="hidden"
                                              scrollRadius={false}
                                              style={
                                                {
                                                  borderTopLeftRadius: 16,
                                                  borderTopRightRadius: 16,
                                                  borderBottomRightRadius: 16,
                                                  borderBottomLeftRadius: 16,
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  backgroundColor:
                                                    "rgba(244, 248, 251, 1)",
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="839774"
                                                id="839774"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="988648"
                                                  id="988648"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={20}
                                                  xxl={20}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                    } as any
                                                  }
                                                >
                                                  <KRow
                                                    key="983919"
                                                    id="983919"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="641317"
                                                      id="641317"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={2}
                                                      xxl={2}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 8,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                        } as any
                                                      }
                                                    >
                                                      <Icon
                                                        key="916076"
                                                        id="916076"
                                                        iconName="local_post_office"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 14,
                                                            borderTopRightRadius: 14,
                                                            borderBottomRightRadius: 14,
                                                            borderBottomLeftRadius: 14,
                                                            backgroundColor:
                                                              "#dff4ea",
                                                            paddingTop: 10,
                                                            paddingRight: 10,
                                                            paddingBottom: 10,
                                                            paddingLeft: 10,
                                                            fontSize: "28px",
                                                            color: "#14b86a",
                                                          } as any
                                                        }
                                                      ></Icon>
                                                    </KCol>
                                                    <KCol
                                                      key="100281"
                                                      id="100281"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={22}
                                                      xxl={22}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 8,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-left",
                                                        } as any
                                                      }
                                                    >
                                                      <VerticalStack
                                                        key="366117"
                                                        id="366117"
                                                        direction="vertical"
                                                        size={2}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <HorizontalStack
                                                          key="153182"
                                                          id="153182"
                                                          direction="horizontal"
                                                          size={12}
                                                          overflowX="auto"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <Label
                                                            key="615610"
                                                            id="615610"
                                                            value="[datafield:baslik]"
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "12px",
                                                              } as any
                                                            }
                                                          ></Label>
                                                        </HorizontalStack>
                                                        <HorizontalStack
                                                          key="258644"
                                                          id="258644"
                                                          direction="horizontal"
                                                          size={12}
                                                          overflowX="auto"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <Label
                                                            key="714652"
                                                            id="714652"
                                                            value="[datafield:mesaj]"
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 400,
                                                                fontSize:
                                                                  "12px",
                                                              } as any
                                                            }
                                                          ></Label>
                                                        </HorizontalStack>
                                                        <HorizontalStack
                                                          key="426070"
                                                          id="426070"
                                                          direction="horizontal"
                                                          size={2}
                                                          overflowX="auto"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <Icon
                                                            key="321171"
                                                            id="321171"
                                                            iconName="person"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(217, 217, 217, 1)",
                                                                letterSpacing:
                                                                  "1px",
                                                              } as any
                                                            }
                                                          ></Icon>
                                                          <Label
                                                            key="981922"
                                                            id="981922"
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 300,
                                                                fontSize:
                                                                  "10px",
                                                                color:
                                                                  "rgba(140, 140, 140, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                          <Label
                                                            key="883632"
                                                            id="883632"
                                                            value={ReactSystemFunctions.translate(
                                                              this.ml,
                                                              883632,
                                                              "value",
                                                              this.defaultML
                                                            )}
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 600,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(255, 255, 255, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                          <Icon
                                                            key="505238"
                                                            id="505238"
                                                            iconName="business"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(217, 217, 217, 1)",
                                                                letterSpacing:
                                                                  "1px",
                                                              } as any
                                                            }
                                                          ></Icon>
                                                          <Label
                                                            key="956688"
                                                            id="956688"
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 300,
                                                                fontSize:
                                                                  "10px",
                                                                color:
                                                                  "rgba(140, 140, 140, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                          <Label
                                                            key="569559"
                                                            id="569559"
                                                            value={ReactSystemFunctions.translate(
                                                              this.ml,
                                                              569559,
                                                              "value",
                                                              this.defaultML
                                                            )}
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 600,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(255, 255, 255, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                          <Icon
                                                            key="789061"
                                                            id="789061"
                                                            iconName="calendar_month"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(217, 217, 217, 1)",
                                                                letterSpacing:
                                                                  "1px",
                                                              } as any
                                                            }
                                                          ></Icon>
                                                          <HorizontalStack
                                                            key="647659"
                                                            id="647659"
                                                            direction="horizontal"
                                                            size={0}
                                                            overflowX="auto"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "14px",
                                                                color:
                                                                  "rgba(68, 68, 68, 1)",
                                                              } as any
                                                            }
                                                          >
                                                            <Label
                                                              key="589776"
                                                              id="589776"
                                                              value="[datafield:projeAdi]"
                                                              writingMode="horizontal"
                                                              style={
                                                                {
                                                                  borderStyle:
                                                                    "solid",
                                                                  borderTopWidth: 0,
                                                                  borderRightWidth: 0,
                                                                  borderBottomWidth: 0,
                                                                  borderLeftWidth: 0,
                                                                  paddingTop: 0,
                                                                  paddingRight: 0,
                                                                  paddingBottom: 0,
                                                                  paddingLeft: 0,
                                                                  alignItems:
                                                                    "center",
                                                                  textAlign:
                                                                    "-webkit-left",
                                                                  display:
                                                                    "inline",
                                                                  fontWeight: 300,
                                                                  fontSize:
                                                                    "10px",
                                                                  color:
                                                                    "rgba(140, 140, 140, 1)",
                                                                } as any
                                                              }
                                                            ></Label>
                                                            <Label
                                                              key="356325"
                                                              id="356325"
                                                              value={ReactSystemFunctions.translate(
                                                                this.ml,
                                                                356325,
                                                                "value",
                                                                this.defaultML
                                                              )}
                                                              writingMode="horizontal"
                                                              style={
                                                                {
                                                                  borderStyle:
                                                                    "solid",
                                                                  borderTopWidth: 0,
                                                                  borderRightWidth: 0,
                                                                  borderBottomWidth: 0,
                                                                  borderLeftWidth: 0,
                                                                  paddingTop: 0,
                                                                  paddingRight: 0,
                                                                  paddingBottom: 0,
                                                                  paddingLeft: 0,
                                                                  alignItems:
                                                                    "center",
                                                                  textAlign:
                                                                    "-webkit-left",
                                                                  display:
                                                                    "inline",
                                                                  fontWeight: 300,
                                                                  fontSize:
                                                                    "10px",
                                                                  color:
                                                                    "rgba(255, 255, 255, 1)",
                                                                } as any
                                                              }
                                                            ></Label>
                                                          </HorizontalStack>
                                                        </HorizontalStack>
                                                      </VerticalStack>
                                                    </KCol>
                                                  </KRow>
                                                </KCol>
                                                <KCol
                                                  key="442978"
                                                  id="442978"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={4}
                                                  xxl={4}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                    } as any
                                                  }
                                                >
                                                  <VerticalStack
                                                    key="486954"
                                                    id="486954"
                                                    direction="vertical"
                                                    size={5}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="626574"
                                                      id="626574"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        626574,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontWeight: 400,
                                                          fontSize: "10px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <HorizontalStack
                                                      key="103630"
                                                      id="103630"
                                                      direction="horizontal"
                                                      size={5}
                                                      overflowX="auto"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Icon
                                                        key="957378"
                                                        id="957378"
                                                        iconName="link"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 4,
                                                            borderTopRightRadius: 4,
                                                            borderBottomRightRadius: 4,
                                                            borderBottomLeftRadius: 4,
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            backgroundColor:
                                                              "rgba(255, 255, 255, 1)",
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "12px",
                                                            color:
                                                              "rgba(155, 155, 155, 1)",
                                                            letterSpacing:
                                                              "1px",
                                                          } as any
                                                        }
                                                      ></Icon>
                                                      <Icon
                                                        key="543338"
                                                        id="543338"
                                                        iconName="delete_outline"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 4,
                                                            borderTopRightRadius: 4,
                                                            borderBottomRightRadius: 4,
                                                            borderBottomLeftRadius: 4,
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            backgroundColor:
                                                              "rgba(255, 255, 255, 1)",
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "12px",
                                                            color:
                                                              "rgba(155, 155, 155, 1)",
                                                            letterSpacing:
                                                              "1px",
                                                          } as any
                                                        }
                                                      ></Icon>
                                                    </HorizontalStack>
                                                  </VerticalStack>
                                                </KCol>
                                              </KRow>
                                            </KPanel>
                                          </KCol>
                                        </KRow>
                                      </KTableColumn>
                                    </KTableRow>
                                  </KTable>
                                </KTabItem>
                                <KTabItem
                                  key={22328}
                                  id="22328"
                                  onActive={(e?: any) => {
                                    if (e && e.stopPropagation)
                                      e.stopPropagation();
                                    this.BildirimListesiComponent_22328_onActive();
                                  }}
                                  tab={ReactSystemFunctions.translate(
                                    this.ml,
                                    22328,
                                    "tab",
                                    this.defaultML
                                  )}
                                  forceRender={false}
                                  style={
                                    {
                                      borderStyle: "solid",
                                      borderTopWidth: 0,
                                      borderRightWidth: 0,
                                      borderBottomWidth: 0,
                                      borderLeftWidth: 0,
                                      backgroundColor: "rgba(255, 255, 255, 1)",
                                      backgroundRepeat: "no-repeat",
                                      backgroundSize: "contain",
                                      backgroundPosition: "left",
                                      paddingTop: 0,
                                      paddingRight: 0,
                                      paddingBottom: 0,
                                      paddingLeft: 0,
                                      fontFamily: "Poppins",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                      color: "rgba(68, 68, 68, 1)",
                                    } as any
                                  }
                                >
                                  <KTable
                                    key="914116"
                                    id="914116"
                                    kuikaRef={
                                      this
                                        .bildirimlistesi_914116_value_kuikaTableRef
                                    }
                                    form={this.props.form}
                                    dataSource={this.state.BildirimleriGetir}
                                    size="middle"
                                    bordered={true}
                                    loading={false}
                                    rowKey="id"
                                    transformedOnMobileResolution={false}
                                    hideHeaderOnMobileResolution={true}
                                    showHeader={false}
                                    fixedHeader={false}
                                    tableWidthMode="fit"
                                    editable={false}
                                    editableAlwaysActive={false}
                                    insertRowActive={false}
                                    insertRowPosition="top"
                                    globalSearch={false}
                                    searchable={false}
                                    shouldSearchOnChange={true}
                                    searchDelay={200}
                                    sorter={false}
                                    filtering={false}
                                    resizableColumns={false}
                                    pagination={true}
                                    pageSize={10}
                                    showSizeChanger={false}
                                    paginationSelectedTextColor="#246eff"
                                    paginationUnselectedTextColor="#000"
                                    columnChooser={false}
                                    striped={false}
                                    stripedColor="#F5F7FA"
                                    rowHoverBgColor="#fafafa"
                                    showRowNumbers={false}
                                    showNoDataFound={true}
                                    nodatafoundmessage={ReactSystemFunctions.translate(
                                      this.ml,
                                      914116,
                                      "nodatafoundmessage",
                                      this.defaultML
                                    )}
                                    multiSelect={false}
                                    multiSelectScope="page"
                                    export={false}
                                    style={
                                      {
                                        borderStyle: "solid",
                                        borderTopWidth: 0,
                                        borderRightWidth: 0,
                                        borderBottomWidth: 0,
                                        borderLeftWidth: 0,
                                        paddingTop: 0,
                                        paddingRight: 0,
                                        paddingBottom: 0,
                                        paddingLeft: 0,
                                        fontFamily: "Poppins",
                                        fontWeight: 500,
                                        fontSize: "14px",
                                        color: "rgba(68, 68, 68, 1)",
                                      } as any
                                    }
                                  >
                                    <KTableHeader
                                      key="581384"
                                      id="581384"
                                      hideOnMobileResolution={false}
                                      textDirection="Default"
                                      style={
                                        {
                                          borderStyle: "solid",
                                          borderTopWidth: 0,
                                          borderRightWidth: 0,
                                          borderBottomWidth: 0,
                                          borderLeftWidth: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: 400,
                                          fontSize: "12px",
                                          color: "rgba(155, 155, 155, 1)",
                                          lineHeight: "20px",
                                        } as any
                                      }
                                    ></KTableHeader>
                                    <KTableRow
                                      key="990185"
                                      id="990185"
                                      hoverFontColor="red"
                                      hoverBgColor="#F5F5F5"
                                      style={
                                        {
                                          paddingTop: 0,
                                          paddingRight: 0,
                                          paddingBottom: 0,
                                          paddingLeft: 0,
                                          fontFamily: "Poppins",
                                          fontWeight: 500,
                                          fontSize: "14px",
                                          color: "rgba(68, 68, 68, 1)",
                                        } as any
                                      }
                                    >
                                      <KTableColumn
                                        key="629896"
                                        id="629896"
                                        title={ReactSystemFunctions.translate(
                                          this.ml,
                                          629896,
                                          "title",
                                          this.defaultML
                                        )}
                                        alwaysVisibleOnMobileResolution={false}
                                        hideFiltering={false}
                                        hideSorting={false}
                                        hideSearch={false}
                                        footerOptions="none"
                                        footerFontSize={14}
                                        footerFontColor="rgb(68, 68, 68)"
                                        excludeFromExport={false}
                                        footerFontWeight="Regular"
                                        style={
                                          {
                                            borderStyle: "solid",
                                            borderTopWidth: 0,
                                            borderRightWidth: 0,
                                            borderBottomWidth: 0,
                                            borderLeftWidth: 0,
                                            paddingTop: 8,
                                            paddingRight: 8,
                                            paddingBottom: 8,
                                            paddingLeft: 8,
                                            alignItems: "center",
                                            textAlign: "-webkit-left",
                                            fontFamily: "Poppins",
                                            fontWeight: 500,
                                            fontSize: "14px",
                                            color: "rgba(68, 68, 68, 1)",
                                          } as any
                                        }
                                      >
                                        <KRow
                                          key="753674"
                                          id="753674"
                                          align="top"
                                          justify="start"
                                          horizontalGutter={0}
                                          verticalGutter={0}
                                          style={
                                            {
                                              borderStyle: "solid",
                                              borderTopWidth: 0,
                                              borderRightWidth: 0,
                                              borderBottomWidth: 0,
                                              borderLeftWidth: 0,
                                            } as any
                                          }
                                        >
                                          <KCol
                                            key="56356"
                                            id="56356"
                                            xs={24}
                                            sm={24}
                                            md={24}
                                            lg={24}
                                            xl={24}
                                            xxl={24}
                                            order={0}
                                            pull={0}
                                            push={0}
                                            style={
                                              {
                                                borderStyle: "solid",
                                                borderTopWidth: 0,
                                                borderRightWidth: 0,
                                                borderBottomWidth: 0,
                                                borderLeftWidth: 0,
                                              } as any
                                            }
                                          >
                                            <KPanel
                                              key="875643"
                                              id="875643"
                                              scrolling="hidden"
                                              scrollRadius={false}
                                              style={
                                                {
                                                  borderTopLeftRadius: 16,
                                                  borderTopRightRadius: 16,
                                                  borderBottomRightRadius: 16,
                                                  borderBottomLeftRadius: 16,
                                                  borderStyle: "solid",
                                                  borderTopWidth: 0,
                                                  borderRightWidth: 0,
                                                  borderBottomWidth: 0,
                                                  borderLeftWidth: 0,
                                                  backgroundColor:
                                                    "rgba(244, 248, 251, 1)",
                                                  paddingTop: 0,
                                                  paddingRight: 0,
                                                  paddingBottom: 0,
                                                  paddingLeft: 0,
                                                } as any
                                              }
                                            >
                                              <KRow
                                                key="577294"
                                                id="577294"
                                                align="top"
                                                justify="start"
                                                horizontalGutter={0}
                                                verticalGutter={0}
                                                style={
                                                  {
                                                    borderStyle: "solid",
                                                    borderTopWidth: 0,
                                                    borderRightWidth: 0,
                                                    borderBottomWidth: 0,
                                                    borderLeftWidth: 0,
                                                    paddingTop: 8,
                                                    paddingRight: 8,
                                                    paddingBottom: 8,
                                                    paddingLeft: 8,
                                                    alignItems: "flex-start",
                                                    textAlign: "-webkit-left",
                                                  } as any
                                                }
                                              >
                                                <KCol
                                                  key="958564"
                                                  id="958564"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={20}
                                                  xxl={20}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "flex-start",
                                                      textAlign: "-webkit-left",
                                                    } as any
                                                  }
                                                >
                                                  <KRow
                                                    key="119089"
                                                    id="119089"
                                                    align="top"
                                                    justify="start"
                                                    horizontalGutter={0}
                                                    verticalGutter={0}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                      } as any
                                                    }
                                                  >
                                                    <KCol
                                                      key="219894"
                                                      id="219894"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={2}
                                                      xxl={2}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 8,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                        } as any
                                                      }
                                                    >
                                                      <Icon
                                                        key="626726"
                                                        id="626726"
                                                        iconName="hourglass_top"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 14,
                                                            borderTopRightRadius: 14,
                                                            borderBottomRightRadius: 14,
                                                            borderBottomLeftRadius: 14,
                                                            backgroundColor:
                                                              "#f9e9e7",
                                                            paddingTop: 10,
                                                            paddingRight: 10,
                                                            paddingBottom: 10,
                                                            paddingLeft: 10,
                                                            fontSize: "28px",
                                                            color: "#f29b38",
                                                          } as any
                                                        }
                                                      ></Icon>
                                                    </KCol>
                                                    <KCol
                                                      key="78661"
                                                      id="78661"
                                                      xs={24}
                                                      sm={24}
                                                      md={24}
                                                      lg={24}
                                                      xl={22}
                                                      xxl={22}
                                                      order={0}
                                                      pull={0}
                                                      push={0}
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 8,
                                                          paddingRight: 8,
                                                          paddingBottom: 8,
                                                          paddingLeft: 8,
                                                          alignItems:
                                                            "flex-start",
                                                          textAlign:
                                                            "-webkit-left",
                                                        } as any
                                                      }
                                                    >
                                                      <VerticalStack
                                                        key="55650"
                                                        id="55650"
                                                        direction="vertical"
                                                        size={2}
                                                        style={
                                                          {
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            paddingTop: 0,
                                                            paddingRight: 0,
                                                            paddingBottom: 0,
                                                            paddingLeft: 0,
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            color:
                                                              "rgba(68, 68, 68, 1)",
                                                          } as any
                                                        }
                                                      >
                                                        <HorizontalStack
                                                          key="699645"
                                                          id="699645"
                                                          direction="horizontal"
                                                          size={12}
                                                          overflowX="auto"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <Label
                                                            key="683821"
                                                            id="683821"
                                                            value="[datafield:baslik]"
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "12px",
                                                              } as any
                                                            }
                                                          ></Label>
                                                        </HorizontalStack>
                                                        <HorizontalStack
                                                          key="353423"
                                                          id="353423"
                                                          direction="horizontal"
                                                          size={12}
                                                          overflowX="auto"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <Label
                                                            key="167290"
                                                            id="167290"
                                                            value="[datafield:mesaj]"
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 400,
                                                                fontSize:
                                                                  "12px",
                                                              } as any
                                                            }
                                                          ></Label>
                                                        </HorizontalStack>
                                                        <HorizontalStack
                                                          key="902469"
                                                          id="902469"
                                                          direction="horizontal"
                                                          size={2}
                                                          overflowX="auto"
                                                          style={
                                                            {
                                                              borderStyle:
                                                                "solid",
                                                              borderTopWidth: 0,
                                                              borderRightWidth: 0,
                                                              borderBottomWidth: 0,
                                                              borderLeftWidth: 0,
                                                              paddingTop: 0,
                                                              paddingRight: 0,
                                                              paddingBottom: 0,
                                                              paddingLeft: 0,
                                                              fontFamily:
                                                                "Poppins",
                                                              fontWeight: 500,
                                                              fontSize: "14px",
                                                              color:
                                                                "rgba(68, 68, 68, 1)",
                                                            } as any
                                                          }
                                                        >
                                                          <Icon
                                                            key="435153"
                                                            id="435153"
                                                            iconName="person"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(217, 217, 217, 1)",
                                                                letterSpacing:
                                                                  "1px",
                                                              } as any
                                                            }
                                                          ></Icon>
                                                          <Label
                                                            key="992735"
                                                            id="992735"
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 300,
                                                                fontSize:
                                                                  "10px",
                                                                color:
                                                                  "rgba(140, 140, 140, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                          <Label
                                                            key="174402"
                                                            id="174402"
                                                            value={ReactSystemFunctions.translate(
                                                              this.ml,
                                                              174402,
                                                              "value",
                                                              this.defaultML
                                                            )}
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 600,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(255, 255, 255, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                          <Icon
                                                            key="689558"
                                                            id="689558"
                                                            iconName="business"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(217, 217, 217, 1)",
                                                                letterSpacing:
                                                                  "1px",
                                                              } as any
                                                            }
                                                          ></Icon>
                                                          <Label
                                                            key="402508"
                                                            id="402508"
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 300,
                                                                fontSize:
                                                                  "10px",
                                                                color:
                                                                  "rgba(140, 140, 140, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                          <Label
                                                            key="921989"
                                                            id="921989"
                                                            value={ReactSystemFunctions.translate(
                                                              this.ml,
                                                              921989,
                                                              "value",
                                                              this.defaultML
                                                            )}
                                                            writingMode="horizontal"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontWeight: 600,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(255, 255, 255, 1)",
                                                              } as any
                                                            }
                                                          ></Label>
                                                          <Icon
                                                            key="743858"
                                                            id="743858"
                                                            iconName="calendar_month"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                alignItems:
                                                                  "center",
                                                                textAlign:
                                                                  "-webkit-left",
                                                                display:
                                                                  "inline",
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "12px",
                                                                color:
                                                                  "rgba(217, 217, 217, 1)",
                                                                letterSpacing:
                                                                  "1px",
                                                              } as any
                                                            }
                                                          ></Icon>
                                                          <HorizontalStack
                                                            key="736391"
                                                            id="736391"
                                                            direction="horizontal"
                                                            size={0}
                                                            overflowX="auto"
                                                            style={
                                                              {
                                                                borderStyle:
                                                                  "solid",
                                                                borderTopWidth: 0,
                                                                borderRightWidth: 0,
                                                                borderBottomWidth: 0,
                                                                borderLeftWidth: 0,
                                                                paddingTop: 0,
                                                                paddingRight: 0,
                                                                paddingBottom: 0,
                                                                paddingLeft: 0,
                                                                fontFamily:
                                                                  "Poppins",
                                                                fontWeight: 500,
                                                                fontSize:
                                                                  "14px",
                                                                color:
                                                                  "rgba(68, 68, 68, 1)",
                                                              } as any
                                                            }
                                                          >
                                                            <Label
                                                              key="433177"
                                                              id="433177"
                                                              value="[datafield:projeAdi]"
                                                              writingMode="horizontal"
                                                              style={
                                                                {
                                                                  borderStyle:
                                                                    "solid",
                                                                  borderTopWidth: 0,
                                                                  borderRightWidth: 0,
                                                                  borderBottomWidth: 0,
                                                                  borderLeftWidth: 0,
                                                                  paddingTop: 0,
                                                                  paddingRight: 0,
                                                                  paddingBottom: 0,
                                                                  paddingLeft: 0,
                                                                  alignItems:
                                                                    "center",
                                                                  textAlign:
                                                                    "-webkit-left",
                                                                  display:
                                                                    "inline",
                                                                  fontWeight: 300,
                                                                  fontSize:
                                                                    "10px",
                                                                  color:
                                                                    "rgba(140, 140, 140, 1)",
                                                                } as any
                                                              }
                                                            ></Label>
                                                            <Label
                                                              key="949714"
                                                              id="949714"
                                                              value={ReactSystemFunctions.translate(
                                                                this.ml,
                                                                949714,
                                                                "value",
                                                                this.defaultML
                                                              )}
                                                              writingMode="horizontal"
                                                              style={
                                                                {
                                                                  borderStyle:
                                                                    "solid",
                                                                  borderTopWidth: 0,
                                                                  borderRightWidth: 0,
                                                                  borderBottomWidth: 0,
                                                                  borderLeftWidth: 0,
                                                                  paddingTop: 0,
                                                                  paddingRight: 0,
                                                                  paddingBottom: 0,
                                                                  paddingLeft: 0,
                                                                  alignItems:
                                                                    "center",
                                                                  textAlign:
                                                                    "-webkit-left",
                                                                  display:
                                                                    "inline",
                                                                  fontWeight: 300,
                                                                  fontSize:
                                                                    "10px",
                                                                  color:
                                                                    "rgba(255, 255, 255, 1)",
                                                                } as any
                                                              }
                                                            ></Label>
                                                          </HorizontalStack>
                                                        </HorizontalStack>
                                                      </VerticalStack>
                                                    </KCol>
                                                  </KRow>
                                                </KCol>
                                                <KCol
                                                  key="571849"
                                                  id="571849"
                                                  xs={24}
                                                  sm={24}
                                                  md={24}
                                                  lg={24}
                                                  xl={4}
                                                  xxl={4}
                                                  order={0}
                                                  pull={0}
                                                  push={0}
                                                  style={
                                                    {
                                                      borderStyle: "solid",
                                                      borderTopWidth: 0,
                                                      borderRightWidth: 0,
                                                      borderBottomWidth: 0,
                                                      borderLeftWidth: 0,
                                                      paddingTop: 8,
                                                      paddingRight: 8,
                                                      paddingBottom: 8,
                                                      paddingLeft: 8,
                                                      alignItems: "center",
                                                      textAlign: "-webkit-left",
                                                    } as any
                                                  }
                                                >
                                                  <VerticalStack
                                                    key="648180"
                                                    id="648180"
                                                    direction="vertical"
                                                    size={5}
                                                    style={
                                                      {
                                                        borderStyle: "solid",
                                                        borderTopWidth: 0,
                                                        borderRightWidth: 0,
                                                        borderBottomWidth: 0,
                                                        borderLeftWidth: 0,
                                                        paddingTop: 0,
                                                        paddingRight: 0,
                                                        paddingBottom: 0,
                                                        paddingLeft: 0,
                                                        fontFamily: "Poppins",
                                                        fontWeight: 500,
                                                        fontSize: "14px",
                                                        color:
                                                          "rgba(68, 68, 68, 1)",
                                                      } as any
                                                    }
                                                  >
                                                    <Label
                                                      key="201169"
                                                      id="201169"
                                                      value={ReactSystemFunctions.translate(
                                                        this.ml,
                                                        201169,
                                                        "value",
                                                        this.defaultML
                                                      )}
                                                      writingMode="horizontal"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          alignItems: "center",
                                                          textAlign:
                                                            "-webkit-left",
                                                          display: "inline",
                                                          fontWeight: 400,
                                                          fontSize: "10px",
                                                        } as any
                                                      }
                                                    ></Label>
                                                    <HorizontalStack
                                                      key="585167"
                                                      id="585167"
                                                      direction="horizontal"
                                                      size={5}
                                                      overflowX="auto"
                                                      style={
                                                        {
                                                          borderStyle: "solid",
                                                          borderTopWidth: 0,
                                                          borderRightWidth: 0,
                                                          borderBottomWidth: 0,
                                                          borderLeftWidth: 0,
                                                          paddingTop: 0,
                                                          paddingRight: 0,
                                                          paddingBottom: 0,
                                                          paddingLeft: 0,
                                                          fontFamily: "Poppins",
                                                          fontWeight: 500,
                                                          fontSize: "14px",
                                                          color:
                                                            "rgba(68, 68, 68, 1)",
                                                        } as any
                                                      }
                                                    >
                                                      <Icon
                                                        key="167007"
                                                        id="167007"
                                                        iconName="link"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 4,
                                                            borderTopRightRadius: 4,
                                                            borderBottomRightRadius: 4,
                                                            borderBottomLeftRadius: 4,
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            backgroundColor:
                                                              "rgba(255, 255, 255, 1)",
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "12px",
                                                            color:
                                                              "rgba(155, 155, 155, 1)",
                                                            letterSpacing:
                                                              "1px",
                                                          } as any
                                                        }
                                                      ></Icon>
                                                      <Icon
                                                        key="444354"
                                                        id="444354"
                                                        iconName="delete_outline"
                                                        style={
                                                          {
                                                            borderTopLeftRadius: 4,
                                                            borderTopRightRadius: 4,
                                                            borderBottomRightRadius: 4,
                                                            borderBottomLeftRadius: 4,
                                                            borderStyle:
                                                              "solid",
                                                            borderTopWidth: 0,
                                                            borderRightWidth: 0,
                                                            borderBottomWidth: 0,
                                                            borderLeftWidth: 0,
                                                            backgroundColor:
                                                              "rgba(255, 255, 255, 1)",
                                                            paddingTop: 8,
                                                            paddingRight: 8,
                                                            paddingBottom: 8,
                                                            paddingLeft: 8,
                                                            alignItems:
                                                              "center",
                                                            textAlign:
                                                              "-webkit-left",
                                                            fontFamily:
                                                              "Poppins",
                                                            fontWeight: 500,
                                                            fontSize: "12px",
                                                            color:
                                                              "rgba(155, 155, 155, 1)",
                                                            letterSpacing:
                                                              "1px",
                                                          } as any
                                                        }
                                                      ></Icon>
                                                    </HorizontalStack>
                                                  </VerticalStack>
                                                </KCol>
                                              </KRow>
                                            </KPanel>
                                          </KCol>
                                        </KRow>
                                      </KTableColumn>
                                    </KTableRow>
                                  </KTable>
                                </KTabItem>
                              </KTab>
                            </Form.Item>
                          </KCol>
                        </KRow>
                      </KCol>
                    </KRow>
                  </KCol>
                </KRow>
              </div>
            </>
          </Form>
        </Spin>
      </>
    );
  }
}

const mapStateToProps = (state: AppState) => {
  return {
    spinnerCount: state.spinnerReducer.spinnerCount,
    photoTakeVisible: state.photoTakeReducer.visible,
    isImportMappedExcelModalVisible:
      state.importMappedExcelModalReducer.visible,
  };
};
const mapDispatchToProps = (dispatch) => ({
  showPhotoTake: () => dispatch(showPhotoTake()),
  hidePhotoTake: () => dispatch(hidePhotoTake()),
  showStripeDrawer: (data, callback, that, future) =>
    dispatch(showStripeDrawer(data, callback, that, future)),
  hideStripeDrawer: (data, callback, that) =>
    dispatch(hideStripeDrawer(data, callback, that)),
  showIyzicoDrawer: (data, callback, that) =>
    dispatch(showIyzicoDrawer(data, callback, that)),
  hideIyzicoDrawer: (data, callback, that) =>
    dispatch(hideIyzicoDrawer(data, callback, that)),
  showImportMappedExcelModal: (
    dsId,
    tableName,
    primaryKey,
    columnMapping,
    parameters
  ) =>
    dispatch(
      showImportMappedExcelModal(
        dsId,
        tableName,
        primaryKey,
        columnMapping,
        parameters
      )
    ),
  hideImportMappedExcelModal: () => dispatch(hideImportMappedExcelModal()),
});
const tmp = withGoogleLogin(
  withContext(
    withScreenInput(
      withForm(
        withHistory(
          connect(mapStateToProps, mapDispatchToProps)(BildirimListesi_Screen)
        )
      )
    )
  )
);
export { tmp as BildirimListesi_Screen };
//export default tmp;
//export { tmp as BildirimListesi_Screen };
